module.exports = __webpack_public_path__ + "img/logo-light_old.ac4d15de.png";